<div class="bloco">
  <h5 class="titulo">Qtde Funcionário Presumida</h5> 
  <div *ngIf="naoEncontrouRegistros">
      <div class="row">
        <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
      </div>
  </div>
  <div *ngIf="naoSolicitou">
      <div class="row">
          <div class="col-auto item">Você não solicitou essa consulta.</div>
        <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
      </div>
  </div>
  <div *ngIf="dados.funcionario">
      <div class="row">
          <div class="item col-auto">{{dados.funcionario.qtde_funcionario_presumido}}</div>
        </div>
  </div>
</div>
  
  